import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=05593cef&"
import script from "./icon.js?vue&type=script&lang=js&"
export * from "./icon.js?vue&type=script&lang=js&"
import style0 from "./icon.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05593cef')) {
      api.createRecord('05593cef', component.options)
    } else {
      api.reload('05593cef', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=05593cef&", function () {
      api.rerender('05593cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/icon.vue"
export default component.exports